export default "__VITE_ASSET__073feb80__"